import { getItem } from "../libs/encryptedStorage";
import en from "../locales/en_US.json";
import ar from "../locales/ar_AR.json";
import sp from "../locales/sp_SP.json";

function getCurrentLocale() {
    let locale = getItem("language") ? getItem("language") : "en";
    let direction = getLocaleDirection(locale);

    let message = { en, ar, sp };
    return {
        locale: locale,
        direction: direction,
        message: message[locale]
    }

}

function getLocaleDirection(locale: any) {
    let dir = "ltr";

    switch (locale) {
        case "en":
            dir = "ltr";
            break;

        case "ar":
            dir = "rtl";
            break;

    }
    return dir;
}

export { getCurrentLocale };